import { render, staticRenderFns } from "./SmallContentHighlight.vue?vue&type=template&id=aba76b2a&scoped=true&"
import script from "./SmallContentHighlight.vue?vue&type=script&lang=ts&"
export * from "./SmallContentHighlight.vue?vue&type=script&lang=ts&"
import style0 from "./SmallContentHighlight.vue?vue&type=style&index=0&id=aba76b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba76b2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
